"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legacyFormMetadataParamsSchema = void 0;
var _zod = require("zod");
var _formMetadataParams = require("./formMetadataParams.schema");
const legacyContentTypeMapping = {
  group: "category",
  db: "collection",
  category: "category",
  collection: "collection"
};

/**
 * Preprocesses legacy `contentType` values before validation against `formMetadataParamsSchema`.
 * - `all` → strips `contentType` and `formId`
 * - `group` → `category`
 * - `db` → `collection`
 * - `category` / `collection` → pass through
 *
 * Case-insensitive matching. See ADR-006 for details.
 */
const legacyFormMetadataParamsSchema = exports.legacyFormMetadataParamsSchema = _zod.z.record(_zod.z.unknown()).transform(input => {
  const contentType = typeof input.contentType === "string" ? input.contentType.toLowerCase() : undefined;
  if (!contentType) return input;
  const mapped = legacyContentTypeMapping[contentType];
  if (mapped) {
    return {
      ...input,
      contentType: mapped
    };
  }
  if (contentType === "all") {
    const {
      contentType: _,
      formId: __,
      ...rest
    } = input;
    return rest;
  }
  return input;
}).pipe(_formMetadataParams.formMetadataParamsSchema);